// extracted by mini-css-extract-plugin
module.exports = {"commentActions":"styles-module__commentActions___2n3DM","likesCount":"styles-module__likesCount___-ed1D","likesCountLiked":"styles-module__likesCountLiked___18suj"};